import { useQuery, gql } from '@apollo/client';

import { handleApolloError } from '@exo/frontend-common-apollo';

export const useRelatedProducts = (productID, fetchPolicy) => {
  const variables = {
    id: productID
  };

  const ESPOT_GQL = gql`
    query RelatedProducts($id: String) {
      product(partnumber: $id) {
        id
        name
        slug
        fullImage
        description
        partnumber
        topParentCatName
        type
        parentCategory {
          id
          identifier
          name
          slug
          parentCategory {
            id
            identifier
          }
        }
        relatedProducts {
          relationType
          product {
            name
            id
            longDescription
            description
            status
            type
            fullImage
            topParentCatName
            partnumber
            attributes {
              id
              name
              value {
                id
                value
                sequence
              }
              categoryName
            }
            availability {
              availableQuantity
              availableDate
              status
            }
          }
        }
      }
    }
  `;

  const { loading, error, data, refetch } = useQuery(ESPOT_GQL, {
    variables,
    ...(fetchPolicy ? { fetchPolicy } : {}),
    context:{clientName:"product"}
  });
  handleApolloError(__filename, error);
  return {
    loadingRelatedProducts: loading,
    dataRelatedProducts: data ? data : {},
    errorRelatedProducts: error,
    refetch
  };
};
